// NotificationProvider.tsx
import React, { createContext, useContext, useState, ReactNode } from "react";

export enum NotificationType {
  SUCCESS = "success",
  ERROR = "error",
}
type Notification = { id: number; type: NotificationType };

type NotificationContextType = {
  notifications: Notification[];
  add: (n: Omit<Notification, "id">) => void;
  remove: (id: number) => void;
};

const NotificationContext = createContext<NotificationContextType | null>(null);
let notificationHandler: NotificationContextType | null = null;

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const add = (n: Omit<Notification, "id">) => {
    setNotifications((prev: any) => [
      ...prev,
      { id: Date.now() + Math.random(), ...n },
    ]);
  };

  const remove = (id: number) => {
    setNotifications((prev: any) => prev.filter((n) => n.id !== id));
  };

  const ctx = { notifications, add, remove };
  notificationHandler = ctx; // global handler

  return (
    <NotificationContext.Provider value={{ notifications, add, remove }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx)
    throw new Error("useNotification must be used within NotificationProvider");
  return ctx;
};

export const notify = () => {
  if (!notificationHandler) {
    throw new Error("Notification handler not ready");
  }
  return notificationHandler;
};
